import React from 'react';
import Widget from './Widget';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart, faRetweet, faComments } from '@fortawesome/free-solid-svg-icons';

const TwitterWidget = ({ id, onClick, hidden = false }) => {
  return (
    <Widget
      id={id}
      onClick={onClick}
      icon={<FontAwesomeIcon icon={faComments} />}
      title="Chess Twitter"
      subtitle="Latest chess discussions"
      hidden={hidden}
    >
      <div className="flex flex-col items-center justify-center h-full p-4 text-center">
        <div className="text-blue-400 text-3xl mb-3">
          <FontAwesomeIcon icon={faComments} />
        </div>
        <div className="text-gray-300 text-sm font-medium mb-2">
          Chess Twitter
        </div>
        <div className="text-gray-500 text-xs mb-3">
          Latest chess discussions & memes
        </div>
        <div className="flex items-center space-x-3 text-xs text-gray-400">
          <div className="flex items-center">
            <FontAwesomeIcon icon={faHeart} className="text-red-400 mr-1" />
            <span>2.4K</span>
          </div>
          <div className="flex items-center">
            <FontAwesomeIcon icon={faRetweet} className="text-green-400 mr-1" />
            <span>890</span>
          </div>
        </div>
      </div>
    </Widget>
  );
};

export default TwitterWidget;